import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useCountdownTimer } from '@/store';
dayjs.extend(duration);

export default function useCountdown(options) {
  const { format, onTimeExpired, onAlarm, alarms } = {
    format: 'mm:ss',
    onTimeExpired: () => {},
    onAlarm: () => {},
    alarms: [],
    ...(options || {}),
  };

  const [endDate, setEndDate] = useState();
  const [timeLeft, setTimeLeft] = useState();
  const [timeLeftString, setTimeLeftString] = useState('00:00');

  const { setTimeLeft: setCountdownTimeLeft } = useCountdownTimer();

  const setNewTime = () => {
    if (endDate) {
      const currentTime = dayjs();
      const diff = endDate.diff(currentTime);
      const diffDuration = dayjs.duration(diff);
      const timeLeftStr = diffDuration.format(format);
      setTimeLeft(diff);
      setTimeLeftString(timeLeftStr);
      setCountdownTimeLeft(diff);
      if (diff <= 0) {
        setEndDate(null);
        onTimeExpired();
      }
      const alarm = alarms.find((a) => a === timeLeftStr);
      if (alarm) {
        onAlarm(alarm);
      }
    }
  };

  const start = (dayjsDate, seconds) => {
    const endTime = dayjsDate.add(seconds + 2, 'Second');
    setEndDate(endTime);
  };

  useEffect(() => {
    const interval = setInterval(() => setNewTime(), 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDate]);

  return {
    timeLeftString,
    timeLeft,
    start,
  };
}
